import * as React from 'react'
import { useInput } from 'react-admin'
import { Checkbox, FormHelperText, FormControlLabel, Grid } from '@mui/material'

export const CheckboxLabels = ({ source, validate, choices, defaultValue = [] }) => {
  const { field, fieldState } = useInput({ source, validate, defaultValue })
  const { error } = fieldState
  const handleChange = (event) => {
    let newValue

    if (event.target.checked) {
      newValue = [...field?.value, event.target.name]
    } else {
      newValue = field?.value.filter((item) => item !== event.target.name)
    }

    field?.onChange(newValue || [])
  }

  return (
    <>
      <Grid container direction='column'>
        {choices.map((choice) => (
          <Grid item xs='auto' key={choice.key}>
            <FormControlLabel
              control={
                <Checkbox
                  name={choice.key}
                  checked={field?.value?.includes(choice.key) || false}
                  disabled={!choice.key}
                  onChange={handleChange}
                />
              }
              label={choice.name}
            />
          </Grid>
        ))}
      </Grid>
      <FormHelperText className='form-helper-text' error>
        {error?.message}
      </FormHelperText>
    </>
  )
}
